export const TOOLTIP_COLUMN_TECHNOLOGY_NAME = "name";

export const TOOLTIP_COLUMN_DATE_NAME = "date";
